import { createAction } from "redux-actions";
import { createRequestActionTypes } from "../../../common/saga/createRequestSaga";

export const [
  PURCHASE_REQUEST_BATCH,
  PURCHASE_REQUEST_BATCH_SUCCESS,
  PURCHASE_REQUEST_BATCH_FAILURE,
  PURCHASE_REQUEST_BATCH_INIT
] = createRequestActionTypes("bookMulti/PURCHASE_REQUEST_BATCH");

export const purchaseRequestBatchAction = createAction(
  PURCHASE_REQUEST_BATCH,
  ({ books, addressType, addressEtc }) => ({
    books,
    addressType,
    addressEtc
  })
);

export const purchaseRequestBatchInit = createAction(PURCHASE_REQUEST_BATCH_INIT);
